document.getElementById("Search").addEventListener("keyup", myFunction);
var predictiveSearchResults = document.querySelector('#predictive-search');
var result_section = document.querySelector('#predictive-search-results');
var x = document.getElementById("Search");

function myFunction() {
  var x = document.getElementById("Search");
  getSearchResults(x.value);
}

function getSearchResults(searchTerm) {
  fetch(window.Shopify.routes.root + `search/suggest.json?q=${searchTerm}&resources[type]=product,collection,page,article&resources[limit]=8&resources[options][fields]=title,product_type,variants.title,body&section_id=predictive-search`)
    .then((response) => response.json())
    .then((suggestions) => {
      open();
      var productSuggestions = suggestions.resources.results.products;
      var collectionSuggestions = suggestions.resources.results.collections;
      var blogSuggestions = suggestions.resources.results.articles;
      var pagesSuggestions = suggestions.resources.results.pages;

      var product_query_string = '';
      if (productSuggestions.length > 0) {
        product_query_string += '<ul id="predictive-search-results-list" class="predictive-search__results-list" role="listbox" aria-labelledby="predictive-search-products">';
        for (var i = 0; i < productSuggestions.length; i++) {
          var productName = productSuggestions[i].title.toLowerCase();

          // Check if the product name does not match the excluded names
          if (
            productName !== '2-year warranty' &&
            productName !== '3-year warranty' &&
            productName !== 'christmas 2023'
          ) {
            var featured_image_url = productSuggestions[i]['featured_image']['url'];
            var featured_image_alt = productSuggestions[i]['featured_image']['alt'];
            product_query_string += '<li class="predictive-search__list-item" role="option"><a href="' + productSuggestions[i].url + '" class="predictive-search__item" tabindex="-1"><img class="predictive-search__image" src="' + featured_image_url + '" alt="' + featured_image_alt + '"  width="50" height="auto"><div class="predictive-search__item-content"><span class="predictive-search__item-heading">' + productSuggestions[i].title + '</span><span class="predictive-search__item-price"><b>' + productSuggestions[i].price + '</b></span></div> </a></li>';
          }
        }
        product_query_string += '</ul>';
      } else {
        product_query_string += '<ul id="predictive-search-list" class="predictive-search__results-list" role="listbox" aria-labelledby="predictive-search-products"> <li class="predictive-search__list-item no-found" role="option"> No result for query ' + searchTerm + '<br/>  </li><li class="predictive-search__list-item no-found" role="option"><a href="/products">See all products</a></li></ul>';
      }

      var collection_query_string = '';
      collection_query_string += `<h5 id="predictive-search-collections" class="predictive-search__heading">
        Collections
        </h5>
        <ul id="predictive-search-list" class="predictive-search__results-list" role="listbox" aria-labelledby="predictive-search-products">`;
      if (collectionSuggestions.length > 0) {
        for (var i = 0; i < collectionSuggestions.length; i++) {
          if (i < 3) {
            collection_query_string += `<li class="predictive-search__list-item" role="option">
            <a href="${collectionSuggestions[i].url}" class="predictive-search__item" tabindex="-1">
            
            <div class="predictive-search__item-content">                
                <span class="predictive-search__item-heading">${collectionSuggestions[i].title}</span>
                
            </div>
            </a>
            </li>`;
          }
        }
      }    
      else {
        collection_query_string += `<li class="predictive-search__list-item no-found" role="option">
        No collection Found
        </li>`;
      }
      collection_query_string += '</ul>';

      var blog_query_string = '';
      blog_query_string += `<h5 id="predictive-search-collections" class="predictive-search__heading">
        Blog Posts
        </h5>
        <ul id="predictive-search-list" class="predictive-search__results-list" role="listbox" aria-labelledby="predictive-search-products">`;
      if (blogSuggestions.length > 0) {
        for (var i = 0; i < blogSuggestions.length; i++) {
          if (i < 3) {
            blog_query_string += `<li class="predictive-search__list-item" role="option">
            <a href="${blogSuggestions[i].url}" class="predictive-search__item" tabindex="-1">
            
            <div class="predictive-search__item-content">                
                <span class="predictive-search__item-heading">${blogSuggestions[i].title}</span>
                
            </div>
            </a>
            </li>`;
          }
        }
      }
      else {
        blog_query_string += `<li class="predictive-search__list-item no-found" role="option">
        No blog post found
        </li>`;
      }
      blog_query_string += '</ul>';

      var page_query_string = '';
      page_query_string += `<h5 id="predictive-search-collections" class="predictive-search__heading">
        pages
        </h5>
        <ul id="predictive-search-list" class="predictive-search__results-list" role="listbox" aria-labelledby="predictive-search-products">`;
      if (pagesSuggestions.length > 0) {

        for (var i = 0; i < pagesSuggestions.length; i++) {
          if (i < 3) {
            page_query_string += `<li class="predictive-search__list-item" role="option">
              <a href="${pagesSuggestions[i].url}" class="predictive-search__item" tabindex="-1">
              
              <div class="predictive-search__item-content">                
                  <span class="predictive-search__item-heading">${pagesSuggestions[i].title}</span>
                  
              </div>
              </a>
              </li>`;
          }
        }
      }
      else {
        page_query_string += `<li class="predictive-search__list-item no-found" role="option">
        No pages found
        </li>`;
      }
      page_query_string += '</ul>';
      result_section.innerHTML = product_query_string + collection_query_string + blog_query_string + page_query_string;
      var innerHTML = result_section.innerHTML;

      $('.predictive-search__item-heading').each(function () {
        var text = $(this).text();
        var searchMask = searchTerm;
        var regEx = new RegExp(searchMask, "gi");
        var replaceMask = '<span class="highlight">' + searchTerm + '</span>';
        var result = text.replace(regEx, replaceMask);
        $(this).html(result);

      });

    })
    .catch((error) => {
      throw error;
    });
}

function open() {
  predictiveSearchResults.style.display = 'block';
}

function close() {
  predictiveSearchResults.style.display = 'none';
}

window.onclick = function (event) {
  predictiveSearchResults.style.display = "none";
};
